import styled from "styled-components";

export const LeadNotifyWrapper = styled.div`
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    position: relative;
`;

export const LeadNotifyMessagingWrapper = styled.div`
    position: fixed;
    height: 420px;
    width: calc(100vw - 20px);
    bottom: -10px;
    left: 10px;
    background: rgb(240, 240, 240);
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    box-shadow: rgba(0, 0, 0, 0.3) 0 0 6px inset, rgba(0, 0, 0, 0.3) 0 0 2px;
    
    .close-button {
        position: absolute;
        right: 0;
        background: #131f28;
        height: 30px;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        top: -5px;
    }

    .floating-title-container {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: -8px;
    }

    .floating-title-container .floating-title {
        background: #131f28;
        color: white;
        width: 60%;
        text-align: center;
        padding: 6px;
        font-size: 16px;
        text-transform: uppercase;
        letter-spacing: 5px;
        border-radius: 50px;
    }
    .notes-body {
        margin: 30px 20px 0 20px;
        height: 270px;
        overflow: auto;
    }
    .notes-body .message-box {
        display: flex;
        flex: 1;
        flex-direction: column;
        margin-bottom: 20px;
    }
    .notes-body .message-box .notes {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
    }
    .notes-body .message-box .notes .note {
        color: #787878;
        font-size: 14px;
    }
    .notes-body .message-box .dates {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
    }
    .notes-body .message-box .dates .date,
    .notes-body .message-box .dates .time {
        color: #cecece;
        font-size: 10px;
        letter-spacing: 1px;
    }
    .messaging-box-input {
        display: flex;
        flex: 1;
        flex-direction: row;
        gap: 10px;
        padding: 0 20px;
    }
    .messaging-box-input .message {
        outline: none;
        background: none;
        border: none;
        width: 100%;
        font-size: 12px;
    }
    .messaging-box-input .send-button {
        border: none;
    }

`;